import { Pipe, PipeTransform } from '@angular/core';
import { EventData } from '../../providers/event';

@Pipe({
  name: 'xls_vars'
})
export class XlsVarsPipe implements PipeTransform {

  constructor() {}

  private vars = {
    "hourStart": "hour_start",
    "hourEnd": "hour_end",
    "dateStart": "date_start",
    "dateEnd": "date_end",
    "totalQuota": "total_quota",
  };

  transform(value: string) {
    return this.vars[value] ? this.vars[value] : value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/xls-api/xls_vars.ts